<template>
	<div class="m-detail-base">
		<slot name="top"></slot>
		
		<slot v-if="$scopedSlots.base" name="base"></slot>
		<div v-else class="base flex">
			<div class="flex-grow">
				<div v-if="$scopedSlots.state" class="state flex-wrap">
					<slot name="state"></slot>
				</div>
				<div v-if="$scopedSlots.title" class="title"><slot name="title"></slot></div>
			</div>
			<div v-if="count" class="count flex-column flex-center">
				<div>{{count.value || '-'}}</div>
				<p>{{count.name}}</p>
			</div>
		</div>

		<div class="info">
			<slot name="info"></slot>
		</div>

		<slot name="bottom"></slot>
	</div>
</template>

<script>
	export default {
		name: 'detailBase',

		props: {
			count: Object
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-base {
		border-radius: .16rem;
		padding: .24rem .28rem 0;
		margin: 0 .2rem .2rem;
		background: #fff;

		&:nth-child(1) {
			margin-top: .2rem;
		}

		.base {
			.state {
				gap: .1rem;

				+ .title {
					margin-top: .2rem;
				}
			}

			.title {
				line-height: .4rem;
				font-size: .32rem;
				word-break: break-word;
			}

			.count {
				box-sizing: border-box;
				min-width: 1.5rem;
				height: .92rem;
				border: .01rem dashed #ddd;
				border-radius: .04rem;
				padding: 0 .14rem;
				margin-left: .24rem;
				font-size: .24rem;
				color: #777;
				background: #F9F9F9;

				div {
					margin-bottom: .1rem;
					font-size: .34rem;
					font-weight: 500;
					color: #FF0101;
				}
			}
		}

		.info {
			padding: .12rem 0;

			&:nth-last-child(n+2) {
				border-bottom: .01rem solid #eee;
			}

			>>> .c-field {
				&-label {
					color: #91A1B9;
				}
			}
		}
	}
</style>
